import React from 'react';
import { storiesOf } from '@storybook/react';
import DeleteModal from './DeleteModal';

storiesOf('Common/Modals/DeleteModal', module)
  .add('View', () => (
    <DeleteModal
      show
      title="Delete"
      onClose={() => {}}
      onConfirm={() => {}}
    >
      Are you sure?
    </DeleteModal>
  ));




// WEBPACK FOOTER //
// ./src/components/common/Modals/DeleteModal/DeleteModal.stories.jsx